import { render, staticRenderFns } from "./ModalCancelPolicy.vue?vue&type=template&id=1d89e677"
import script from "./ModalCancelPolicy.vue?vue&type=script&lang=js"
export * from "./ModalCancelPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports